import EventEmitter from 'events';
import ZonePricetype from './ZonePricetype';
import EditableZonePriceType from './EditableZonePriceType';


class PricetypeSelector extends EventEmitter {
  /**
   * @param {HTMLElement} el
   * @param {string} zoneId
   */
  constructor(el, zoneId) {
    super();

    this.el = el;
    this.zoneId = zoneId;

    const zonePricetypes = Array.from(this.el.querySelectorAll('.tn-ticket-selector__pricetype'))
      .map($pricetype => this.createZonePricetype($pricetype));

    this.zonePricetypes = new Map(
      zonePricetypes.map(p => [p.id, p]),
    );

    if (this.values[0].hasQuantitySelect) {
      this.maxQuantity = parseInt(this.el.getAttribute('data-tn-max-quantity'), 10);

      this.updateSelectsForMax();
    }
  }

  get values() {
    return [...this.zonePricetypes.values()];
  }

  createZonePricetype($el) {
    const zonePricetype = $el.hasAttribute('data-tn-price-editable') ?
      new EditableZonePriceType($el) :
      new ZonePricetype($el);

    zonePricetype.on('quantity-change', this.onSelectChange);
    zonePricetype.on('price-change', this.notifyChange);

    return zonePricetype;
  }

  hasPricetype(pricetypeId) {
    return this.zonePricetypes.has(parseInt(pricetypeId, 10));
  }

  getMaxQuantity() {
    return this.maxQuantity;
  }

  getAllPricetypeQuantities() {
    return this.values.map(p => p.getData());
  }

  getIsSelectionValid() {
    if (this.getTotalQuantitySelected() === 0) {
      return false;
    }

    return this.values.every(p => p.getIsPriceValid());
  }

  /**
   * @param {number} pricetypeId
   * @param {number} quantity
   */
  setSelectedQuantityForPricetype(pricetypeId, quantity) {
    const zonePricetype = this.zonePricetypes.get(parseInt(pricetypeId, 10));

    zonePricetype.setSelectedQuantity(quantity);
  }

  updateSelectsForMax() {
    const { maxQuantity } = this;
    const totalQuantitySelected = this.getTotalQuantitySelected();
    const totalRemaining = maxQuantity - totalQuantitySelected;

    // console.log({ totalRemaining, totalQuantitySelected, maxQuantity });

    this.zonePricetypes.forEach((zonePricetype) => {
      zonePricetype.limitQuantityOptions(totalRemaining, maxQuantity);
    });
  }

  onSelectChange = () => {
    this.updateSelectsForMax();
    this.notifyChange();
  }

  notifyChange = () => {
    this.emit('change');
  }

  getTotalQuantitySelected() {
    return this.values
      .reduce((sum, p) => sum + p.getQuantity(), 0);
  }

  show() {
    this.el.style.display = '';
  }

  hide() {
    this.el.style.display = 'none';
  }

  destroy() {
    this.removeAllListeners();

    this.values.forEach(p => p.destroy());
  }
}

export default PricetypeSelector;



// WEBPACK FOOTER //
// ./src/events/detail/PricetypeSelector.js